<template>
  <v-dialog
    v-model="dialogLocal"
    width="500"
  >
    <v-card>
      <v-card-title
        class="headline"
        :class="['grey', $vuetify.theme.dark ? 'darken-3' : 'lighten-2']"
        primary-title
      >
        Upload Profile Image
        <v-spacer />
        <v-btn
          icon
          @click="dialogLocal = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text-center px-0">
        <input
          v-show="false"
          ref="input"
          type="file"
          name="image"
          accept="image/*"
          @change="setImage"
        />

        <vue-cropper
          v-show="imgSrc"
          id="cropper"
          ref="cropper"
          :aspect-ratio="1"
          :src="imgSrc"
          :container-style="{
            height: '50vh'
          }"
          :view-mode="2"
          :background="false"
        />

        <v-btn
          color="primary"
          class="mt-5"
          @click="showFileChooser"
        >
          <v-icon left>
            mdi-plus-circle-outline
          </v-icon> New Image
        </v-btn>

        <div>Please upload an image less than 3MB and 2000 x 2000 pixels</div>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          icon
          color="primary"
          :disabled="!imgSrc"
          @click="flipX"
        >
          <v-icon>mdi-axis-z-rotate-clockwise</v-icon>
        </v-btn>
        <v-btn
          icon
          color="primary"
          :disabled="!imgSrc"
          @click="flipY"
        >
          <v-icon>mdi-horizontal-rotate-clockwise</v-icon>
        </v-btn>
        <v-btn
          icon
          color="primary"
          :disabled="!imgSrc"
          @click="rotate(-90)"
        >
          <v-icon>mdi-rotate-left</v-icon>
        </v-btn>
        <v-btn
          icon
          color="primary"
          :disabled="!imgSrc"
          @click="rotate(90)"
        >
          <v-icon>mdi-rotate-right</v-icon>
        </v-btn>

        <v-spacer />
        <v-btn
          color="primary"
          :loading="isUploading"
          @click="upload"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import accountApi from '@/api/account/account';

export default {
  components: {
    VueCropper,
  },

  props: {
    dialog: {
      type: Boolean,
      default: false,
    },

    uuid: {
      type: String,
      default: '',
    },

    image: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isUploading: false,
      imgName: '',
      imgType: '',
      imgSrc: '',
      scaleX: 1,
      scaleY: 1,
    };
  },

  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(newValue) {
        this.$emit('update:dialog', newValue);
      },
    },
  },

  watch: {
    dialog(val) {
      if (val) { // Open dialog
        // console.log(this.image);
        // Should load image into cropper?
      } else { // Close dialog
        this.$refs.cropper.destroy();
        this.imgSrc = '';
        this.imgType = '';
        this.imgName = '';
      }
    },
  },

  methods: {
    ...mapActions('account', [
      'updateProfileImage',
    ]),

    async upload() {
      this.isUploading = true;
      try {
        const canvas = this.$refs.cropper.getCroppedCanvas();
        const blob = await new Promise((resolve) => canvas.toBlob(resolve, this.imgType, 1));
        const formData = new FormData();
        formData.append('image', blob, this.imgName);

        const response = await accountApi.patchProfileImage(formData);

        this.$toast.success('Image uploaded');
        this.$emit('update:image', response.image);
        this.updateProfileImage(response.image);
        this.dialogLocal = false;
      } catch (error) {
        console.log(error);
        this.$toast.error('An error happened');
      } finally {
        this.isUploading = false;
      }
    },

    flipX() {
      this.scaleX = -this.scaleX;
      this.$refs.cropper.scaleX(this.scaleX);
    },

    flipY() {
      this.scaleY = -this.scaleY;
      this.$refs.cropper.scaleY(this.scaleY);
    },

    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },

    setImage(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.type.indexOf('image/') === -1) {
        this.$toast.error('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
        this.imgName = file.name;
        this.imgType = file.type;
      } else {
        this.$toast.error('Sorry, FileReader API not supported');
      }
    },

    showFileChooser() {
      this.$refs.input.click();
    },
  },
};
</script>

<style lang="scss">
#cropper {
  .cropper-view-box {
    border-radius: 50%;
  }
}
</style>
